/**
 * changePasswordCtrlModule 用户强制修改密码
 * author: Qian.qianchen 2019-09-23
 */
'use strict';
angular.module('changePasswordCtrlModule', []).controller('changePasswordCtrl', ['$scope', '$modalInstance', 'trsHttpService', 'modalDialog', '$validation', '$element', 'localStorageService', '$state', '$q', '$sessionStorage',
    function($scope, $modalInstance, trsHttpService, modalDialog, $validation, $element, localStorageService, $state, $q, $sessionStorage) {
        initStatus();

        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                isShowPassword: false
            };
            $scope.data = {
                sNewPassWord: '',
                sOldPassWord: ''
            };
        }

        /**
         * [resetPassword description] 修改密码
         * @return {[type]} [description]
         */
        function resetPassword() {
            let defer = $q.defer();
            let params = {
                methodname: 'forceUserResetPWd',
                serviceid: 'mlf_extuser',
                sNewPassWord: $scope.data.sNewPassWord,
                sOldPassWord: $scope.data.sOldPassWord
            };
            require(['JSEncrypt'], (JSEncrypt) => {
                let encryptConstructor = JSEncrypt.JSEncrypt;
                let publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCnerB1U8dQy/xDNEGYyqyDJVypiCXDoAwnx6dMfI1r2d2/36gJIiT3H3MAzNkZObLa0se1jB114X4sNb9HgggdQPGVU+X6VPBXv1xwAsP+hivKdqui79hZ+KUoBXysEbGZzRBpAQxmhDNSmK63YUJ9IiTHwKbARmlYZnI9oEyrIwIDAQAB';
                let encrypt = new encryptConstructor();
                encrypt.setPublicKey(publicKey);
                params.sNewPassWord = encrypt.encrypt(params.sNewPassWord);
                params.sOldPassWord = encrypt.encrypt(params.sOldPassWord);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then((result) => {
                    if (result.CODE == 0) {
                        defer.resolve(result.MESSAGE);
                    } else {
                        defer.reject(result.MESSAGE);
                    }
                });
            });
            return defer.promise;
        }

        /**
         * [logout description] 退出登录
         * @return {[type]} [description]
         */
        function logout() {
            // localStorageService.remove('currLoginUser'); // session改变
            $sessionStorage.remove('currLoginUser');
            // localStorageService.remove('mlfCachedUser'); // session改变
            $sessionStorage.remove('mlfCachedUser');
            $('#unreadPrompt_js').hide(); // 关闭传稿提示框
            // $scope.checkLoginOutIframeSrc = $location.path().split("/")[0] + "/wcm/logout.jsp";
            $.ajax({
                url: '/wcm/logout.jsp',
                method: 'get',
                async: false,
                success: function() {},
                error: function() {
                    // modalDialog.alertType('退出异常！',"", "warning", false);
                }
            });
            $state.go('front', {}, { reload: true });
        }

        /**
         * [close description] 关闭
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
            logout();
        };

        /**
         * [confirm description] 确认修改密码
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            let defer = $q.defer();
            $scope.passwordForm.$pending = {};
            $validation.validate($scope.passwordForm)
                .success(() => {
                    resetPassword().then((msg) => {
                        modalDialog.alertType('', msg, 'success', false, () => {
                            $modalInstance.close();
                            defer.resolve();
                        });
                    }, (msg) => {
                        modalDialog.alertType('', msg, 'error', false);
                    });
                }).error(function(msg) {
                    angular.invalidPosition($scope.passwordForm, $element);
                });
            return defer.promise;
        };
    }
]);
